<template>
<div>
<h2 class="title">Adopt</h2>
<div class="container">
<p v-html="pages.content.rendered"></p>
<h3>{{$route.params.slug}}</h3>
</div>
</div>
</template>
<style lang="scss" scoped>

</style>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      slug: this.$route.params.slug,
      pages: [],
    };
  },

  async created() {
    try {
      const response = await axios.get(`http://tribeagle.test/wp-json/wp/v2/pages/?slug=${this.slug}`);
      this.pages = response.data[0];
    } catch (e) {
      this.errors.push(e);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Adopt.vue